import { jsx } from "react/jsx-runtime";
const ArrowIosLeft = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.64 5.232a1 1 0 0 1 .128 1.408L10.302 12l4.466 5.36a1 1 0 0 1-1.536 1.28l-5-6a1 1 0 0 1 0-1.28l5-6a1 1 0 0 1 1.408-.128Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const ArrowIosLeft_ArrowIosLeft = ArrowIosLeft;
export default ArrowIosLeft_ArrowIosLeft;
